import { api } from "./BackendService";

export const create = (data) => api.post("/notifications", data);
export const createAll = (data) => api.post("/notifications/all", data);
export const createByProject = (data) => api.post("/notifications/project", data);
export const getById = (id) => api.get(`/notifications/${id}`);
export const list = (page) =>
  api.get("/notifications", { params: { page: page } });
export const remove = (id) => api.delete(`/notifications/${id}`);
